/* empty css                                                              */
import { _ as o } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { c as s, e as n, j as a } from "./define-element-XpjsV6s1.js";
const c = ["href"], f = {
  __name: "Link",
  props: {
    href: {
      type: String,
      default: "#"
    }
  },
  setup(e) {
    const t = e;
    return (r, p) => (s(), n("a", {
      href: t.href,
      class: "offset-link"
    }, [
      a(r.$slots, "default", {}, void 0, !0)
    ], 8, c));
  }
}, l = /* @__PURE__ */ o(f, [["__scopeId", "data-v-63dfd278"]]);
export {
  l as L
};
